import React, { useState } from "react";
import DeleteButton from "@/ui-controls/DeleteButton";
import CancelButton from "@/ui-controls/CancelButton";
import TextInput from "@/ui-controls/TextInput";
import { Grid } from "fluentui-react-grid";
import { Role, deleteRole as deleteRoleApi } from "@/api/roles";
import { useFormik } from "formik";
import * as Yup from "yup";

interface Props {
  role: Role;
  onDelete?: (role: Role) => any;
  onClose?: () => any;
}

const DeleteAppRoleForm = (props: Props) => {
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const onCancelForm = () => {
    if (props.onClose) props.onClose();
  };

  const deleteRole = () => {
    setIsDeleting(true);

    deleteRoleApi(props.role.Id).then(
      (result: boolean) => {
        setIsDeleting(false);
        if (result) {
          if (props.onDelete) props.onDelete(props.role);
        }
      },
      (error) => {
        setIsDeleting(false);
        handleError(error);
      }
    );
  };

  const formik = useFormik({
    initialValues: { name: "" },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Name is required")
        .max(250)
        .oneOf([props.role?.Name], "Invalid role name"),
    }),
    onSubmit: (values) => {
      deleteRole();
    },
  });

  const handleError = (error: any) => {
    // Error handled by parent component
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid dir="ltr">
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              <TextInput
                label="Confirm Role Name"
                baseTypeProps={{
                  disabled: isDeleting,
                  ...formik.getFieldProps("name"),
                }}
                hasError={formik.errors.name && formik.touched.name}
                errorMessage={formik.errors.name}
              />
            </Grid.Col>
          </Grid.Row>
          <Grid.Row className="panel-buttons">
            <Grid.Col>
              <DeleteButton
                text="Delete"
                baseTypeProps={{ type: "submit", disabled: isDeleting }}
              />
            </Grid.Col>
            <Grid.Col>
              <CancelButton
                text="Cancel"
                onClick={onCancelForm}
                baseTypeProps={{ disabled: isDeleting }}
              />
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </form>
    </>
  );
};

export default DeleteAppRoleForm;
